import { Button, Drawer, Flex, Group, Title, useMantineTheme } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import ErrorAlert from 'components/shared/ErrorAlert';
import { withAsyncContent } from 'hocs/withAsyncContent';
import { meetingDrawer } from 'stores/global/RootStore';
import { useMeetingUpdateDrawerModal } from 'stores/global/RootStore/MeetingUpdateDrawerModal';
import { useAppConfig } from 'stores/global/RootStore/context';
import { useDevices } from 'utils/devices';

import Text from '../Text';

import Detail from './Detail';

import s from './MeetingDrawer.module.scss';

const AsyncDetails = withAsyncContent(Detail, {
  ComponentEmpty: ErrorAlert,
});

const MeetingDrawer: React.FC = () => {
  const { isPhone } = useDevices();
  const theme = useMantineTheme();
  const { logic } = useAppConfig();
  const meetingUpdateDrawerModal = useMeetingUpdateDrawerModal();

  const handleUpdateMeeting = React.useCallback(() => {
    if (meetingDrawer.meeting.value) {
      meetingUpdateDrawerModal.openWithMeeting(meetingDrawer.meeting.value.id);
      meetingDrawer.close();
    }
  }, [meetingUpdateDrawerModal]);

  return (
    <Drawer.Root
      opened={meetingDrawer.isOpen}
      onClose={meetingDrawer.close}
      position="right"
      size={isPhone ? '100%' : 'md'}
      offset={isPhone ? 0 : theme.spacing.lg}
      radius={isPhone ? 0 : 'md'}
      padding={0}
    >
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Body p={0} className={s.root}>
          <Group wrap="nowrap" align="flex-start" justify="space-between" className={s.root__header}>
            <Title size={isPhone ? 'h3' : 'h2'} fw={600}>
              Информация о встрече
            </Title>
            <Drawer.CloseButton onClick={meetingDrawer.close} size={32} icon={<IconX size={24} />} />
          </Group>
          {meetingDrawer.isOpen && (
            <div className={s.root__content}>
              <AsyncDetails loadingStage={meetingDrawer.loadingStage} isEmpty={!meetingDrawer.meeting.value} />
            </div>
          )}
          {meetingDrawer.canCancelMeeting &&
            (logic.meeting.showCancelMeetingButton || logic.meeting.showUpdateMeetingButton) && (
              <div className={s.root__footer}>
                <Flex gap="md">
                  {logic.meeting.showUpdateMeetingButton && meetingDrawer.canEditMeeting && (
                    <Button
                      disabled={meetingDrawer.loadingStage.isLoading}
                      variant="primary"
                      fullWidth
                      onClick={handleUpdateMeeting}
                    >
                      <Text size="lg">Изменить</Text>
                    </Button>
                  )}
                  {logic.meeting.showCancelMeetingButton && meetingDrawer.canCancelMeeting && (
                    <Button
                      disabled={meetingDrawer.loadingStage.isLoading}
                      loading={meetingDrawer.loadingStage.isLoading}
                      variant="outline"
                      fullWidth
                      onClick={meetingDrawer.cancelMeeting}
                    >
                      <Text size="lg">Отменить</Text>
                    </Button>
                  )}
                </Flex>
              </div>
            )}
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
};

export default observer(MeetingDrawer);
